module.exports = __webpack_public_path__ + "img/60-green.cebd4c23.svg";